module.exports = {"views.headerAndSidebarLayout.sidebar.navList.item1":"Suscripciones","views.headerAndSidebarLayout.sidebar.navList.item2":"Ajustes","views.headerAndSidebarLayout.sidebar.navList.item3":"Política de datos","views.headerAndSidebarLayout.sidebar.description":"¿Necesitas ayuda? Por favor contáctanos a ","views.headerAndSidebarLayout.sidebar.customerCare":"atención al cliente","views.headerAndSidebarLayout.header.signOut.text":"Cerrar Sesión","views.headerAndSidebarLayout.header.contactUs.text":"Contáctanos"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/es/views/HeaderAndSidebarLayout.json
// module id = 744
// module chunks = 0